/**
 * Modal de qualification en masse des clients
 */
import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../utils/apiConfig';

const BulkQualifyModal = ({ token, selectedClients, clients, onClose, onSuccess }) => {
  const [selectedType, setSelectedType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleQualify = async () => {
    if (!selectedType) {
      setError('Veuillez selectionner un type');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(API_ENDPOINTS.CLIENTS_BULK_QUALIFY, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          client_ids: selectedClients,
          client_type: selectedType
        })
      });

      const data = await response.json();

      if (data.success) {
        onSuccess();
      } else {
        setError(data.error || 'Erreur lors de la qualification');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  const typeOptions = [
    { value: 'client', label: 'Client', color: '#28a745', desc: 'Vrai client (donneur d\'ordres)' },
    { value: 'partenaire', label: 'Partenaire', color: '#17a2b8', desc: 'Partenaire commercial' },
    { value: 'agence_interim', label: 'Agence interim', color: '#6f42c1', desc: 'Societe d\'interim' }
  ];

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        background: 'white',
        borderRadius: '16px',
        padding: '30px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '80vh',
        overflow: 'auto'
      }}>
        <h2 style={{ margin: '0 0 20px 0' }}>Qualifier {selectedClients.length} client(s)</h2>

        {error && (
          <div style={{
            background: '#f8d7da',
            color: '#721c24',
            padding: '10px',
            borderRadius: '8px',
            marginBottom: '15px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <p style={{ marginBottom: '10px', color: '#666' }}>
            Clients selectionnes :
          </p>
          <div style={{
            maxHeight: '150px',
            overflow: 'auto',
            background: '#f8f9fa',
            padding: '10px',
            borderRadius: '8px',
            fontSize: '13px'
          }}>
            {clients.map(c => (
              <div key={c.id} style={{ padding: '4px 0' }}>
                <strong>{c.code}</strong> - {c.name}
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Qualifier comme :
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {typeOptions.map(type => (
              <label
                key={type.value}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  border: `2px solid ${selectedType === type.value ? type.color : '#dee2e6'}`,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: selectedType === type.value ? `${type.color}15` : 'white',
                  transition: 'all 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="client_type"
                  value={type.value}
                  checked={selectedType === type.value}
                  onChange={(e) => setSelectedType(e.target.value)}
                  style={{ width: '18px', height: '18px' }}
                />
                <div>
                  <div style={{ fontWeight: '600', color: type.color }}>{type.label}</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>{type.desc}</div>
                </div>
              </label>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              flex: 1,
              padding: '12px',
              border: '2px solid #e1e5e9',
              borderRadius: '8px',
              background: 'white',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Annuler
          </button>
          <button
            onClick={handleQualify}
            disabled={loading || !selectedType}
            style={{
              flex: 1,
              padding: '12px',
              border: 'none',
              borderRadius: '8px',
              background: loading || !selectedType ? '#e9ecef' : 'linear-gradient(135deg, #6f42c1, #5a32a3)',
              color: loading || !selectedType ? '#6c757d' : 'white',
              cursor: loading || !selectedType ? 'not-allowed' : 'pointer',
              fontWeight: '600'
            }}
          >
            {loading ? 'En cours...' : 'Qualifier'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkQualifyModal;
